import React from 'react';
import { Box, Container, Typography, IconButton, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LinkedIn } from '@mui/icons-material';
import {grey} from "@mui/material/colors";

const Footer = () => {
 const { t } = useTranslation('general');

 const products = [
   { label: t('footer.aboutUs'), to: '/about-us' },
   { label: t('footer.whyWorldExplore'), to: '/why-worldexplore' },
   { label: t('footer.allFeatures'), to: '/all-features' },
 ];

 const links = [
  { label: t('footer.contact'), to: '/contact' },
   { label: t('footer.privacy'), to: '/privacy' },
   { label: t('footer.terms'), to: '/terms' },
   { label: t('footer.imprint'), to: '/imprint' },
 ];

 const socialLinks = [
   { icon: LinkedIn, href: 'https://www.linkedin.com/company/worldexplore/' }
   // { icon: Twitter, href: 'https://twitter.com' },
   // { icon: Instagram, href: 'https://instagram.com' }
 ];

 return (
   <Box
     component="footer"
     // className={"footer-bg"}
     sx={{
       bgcolor: 'primary.main',
       borderTop: '1px solid',
       color: "#fefefe",
       borderColor: 'divider',
       py: 3,
       position: 'relative',
     }}
   >
     <Container maxWidth="lg">
       <Box
         sx={{
           display: 'flex',
           flexDirection: { xs: 'column', sm: 'row' },
           alignItems: 'flex-start',
           justifyContent: 'space-between',
           gap: 2, py: 10
         }}
       >
         <Box sx={{ display: 'flex', flexDirection: "column", gap: 1 }}>
           <Typography sx={{pb: 1}} fontWeight={600}>{t("footer.products")}</Typography>
           {products.map((link) => (
             <Link
               key={link.to}
               component={RouterLink}
               to={link.to}
               style={{fontSize: "1rem", color: grey[400]}}
             >
               {link.label}
             </Link>
           ))}
         </Box>
         <Box sx={{ display: 'flex', flexDirection: "column", gap: 1 }}>
           <Typography sx={{pb: 1}} fontWeight={600}>{t("footer.support")}</Typography>
           {links.map((link) => (
             <Link
               key={link.to}
               component={RouterLink}
               to={link.to}
               style={{fontSize: "1rem", color: grey[400]}}
             >
               {link.label}
             </Link>
           ))}
         </Box>

         <Box sx={{ display: 'flex', gap: 2 }}>
           {socialLinks.map(({ icon: Icon, href }) => (
             <IconButton
               key={href}
               href={href}
               target="_blank"
               rel="noopener noreferrer"
               sx={{color: grey[400]}}
             >
               <Icon />
             </IconButton>
           ))}
         </Box>
       </Box>

       <Typography 
         variant="body2" 
         align="center"
         sx={{ mt: 2 }}
       >
         © {new Date().getFullYear()} WorldExplore. {t('footer.rights')}
       </Typography>
     </Container>
   </Box>
 );
};

export default Footer;